import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';
import '../styles/Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();
  
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    setLoginError(null);
    
    try {
      const result = await login(data.email, data.password);
      
      if (result.success) {
        toast.success('¡Bienvenido!');
        navigate('/extractor');
      } else {
        setLoginError(result.error);
        toast.error(result.error);
      }
    } catch (error) {
      const msg = 'Error inesperado al iniciar sesión';
      setLoginError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-bg d-flex align-items-center justify-content-center min-vh-100">
      <div className="auth-card shadow-lg rounded-4 p-4" style={{ background: 'rgba(255,255,255,0.97)', minWidth: 340, maxWidth: 400 }}>
        <div className="text-center mb-4">
          <i className="bi bi-file-pdf display-4 text-primary mb-2"></i>
          <h1 className="fw-bold mb-1" style={{ letterSpacing: 1 }}>DataExtractor</h1>
          <div className="text-muted mb-2" style={{ fontSize: '1.1rem' }}>Accede a tu cuenta</div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {loginError && (
            <div className="alert alert-danger" role="alert">
              {loginError}
            </div>
          )}
          <div className="form-group mb-3">
            <label htmlFor="email" className="form-label">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              className="form-control"
              {...register('email', {
                required: 'El correo electrónico es requerido',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Formato de correo inválido'
                }
              })}
              placeholder="tu@email.com"
              autoComplete="username"
            />
            {errors.email && (
              <div className="error-message">{errors.email.message}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="password" className="form-label">Contraseña</label>
            <input
              type="password"
              id="password"
              className="form-control"
              {...register('password', {
                required: 'La contraseña es requerida',
                minLength: {
                  value: 6,
                  message: 'La contraseña debe tener al menos 6 caracteres'
                }
              })}
              placeholder="Tu contraseña"
              autoComplete="current-password"
            />
            {errors.password && (
              <div className="error-message">{errors.password.message}</div>
            )}
          </div>
          <button 
            type="submit" 
            className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 mb-3"
            disabled={loading}
            style={{ fontWeight: 600, fontSize: '1.1rem' }}
          >
            <i className="bi bi-box-arrow-in-right"></i>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
        <div className="auth-links text-center mt-3">
          <Link to="/forgot-password" className="d-block mb-2">¿Olvidaste tu contraseña?</Link>
          <div className="divider small">
            ¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
